module.exports = __webpack_public_path__ + "assets/img/favicon/ms-icon-310x310.ac631ab81b1914c0dcb2361bc3a8cd1d.png";